Backbone = require("backbone")
MainView   = require("views/main")

class AppRouter extends Backbone.Router

  initialize: ->
    @mainView = new MainView(el: "body")

  routes:
    "slide(/:index)(?:query)": "slide"
    "*default": "default"

  # Every time navigating with the history of the iframe
  # it will append to history of parent as well
  # we make sure we add replace to the options to not append to parent history
  doNavigate: (route) ->
    @navigate route, {replace: true, trigger: true}

  default: ->
    @doNavigate("slide/1")

  slide: (index = 1, query = "") ->
    params = {}

    for param in query.split("&") when param
      [key, val] = param.split("=")
      params[key] = try JSON.parse(val) catch val

    @mainView.display("slides", _.extend params, { index })

module.exports = AppRouter
